<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading" class="flex flex-col">

    <!-- CONTEÚDO PRINCIPAL -->
    <div class="flex-1">
        <div class="max-w-4xl ">

            <!-- DADOS DO PACIENTE -->
            <div class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-4">
                    Dados do {{ vm.moduleNameInSingular }}
                </h3>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <p class="text-xs text-gray-500 uppercase mb-1">Nome</p>
                        <p class="text-sm font-medium text-gray-800">{{ patientName || '-' }}</p>
                    </div>
                    <div>
                        <p class="text-xs text-gray-500 uppercase mb-1">Email</p>
                        <p class="text-sm font-medium text-gray-800">{{ patientEmail || '-' }}</p>
                    </div>
                </div>
            </div>

            <!-- CARD DO LINK -->
            <div *ngIf="anamneseUrl" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-4 flex items-center gap-2">
                    <fa-icon [icon]="faExternalLinkAlt" class="text-westetics-purple-600"></fa-icon>
                    Link {{ vm.moduleName === 'PACIENTES' ? 'da Anamnese' : 'do Formulário' }}
                </h3>

                <!-- Input com link -->
                <div class="flex gap-2 mb-4">
                    <input 
                        type="text" 
                        [value]="anamneseUrl" 
                        readonly
                        class="flex-1 bg-gray-50 border border-gray-300 text-gray-700 text-sm rounded-lg p-3"
                    />
                    <button 
                        (click)="copyLink()"
                        class="px-4 py-2 text-sm font-medium rounded-lg transition-colors flex items-center gap-2"
                        [ngClass]="showCopySuccess ? 'bg-green-100 text-green-700' : 'bg-westetics-purple-100 text-westetics-purple-800 hover:bg-westetics-purple-200'"
                    >
                        <fa-icon [icon]="showCopySuccess ? faCheck : faCopy"></fa-icon>
                        {{ showCopySuccess ? 'Copiado!' : 'Copiar' }}
                    </button>
                </div>
            </div>

            <!-- QR CODE -->
            <div *ngIf="anamneseUrl" class="bg-white rounded-lg border border-gray-200 p-6 mb-6">
                <h3 class="text-base font-semibold text-westetics-neutral-950 mb-4 flex items-center gap-2">
                    <fa-icon [icon]="faQrcode" class="text-westetics-purple-600"></fa-icon>
                    QR Code
                </h3>
                <p class="text-sm text-gray-600 mb-4">
                    O {{ vm.moduleNameInSingular }} pode escanear este QR Code para acessar {{ vm.moduleName === 'PACIENTES' ? 'a anamnese' : 'o formulário' }}.
                </p>
                <div class="flex justify-center">
                    <qrcode
                        [qrdata]="anamneseUrl"
                        [allowEmptyString]="true"
                        [width]="200"
                        [errorCorrectionLevel]="'M'"
                    ></qrcode>
                </div>
            </div>

        </div>
    </div>

</div>
</ng-container>
